import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { FiltroProdutoLista, Produto } from '../interface/produto';

@Injectable({
  providedIn: 'root'
})
export class ProdutoLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrproduto`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<Produto> {
    return this.httpClient.get<Produto>(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CB1COD'   , optional: true, gridColumns: 6, label: 'Codigo'},
      {property: 'CB1DESC'  , optional: true, gridColumns: 6, label: 'Descrição'},
      {property: 'CB1POSIPI', optional: true, gridColumns: 6, label: 'NCM'},
    ];
  }

  getAdvancedFilterPDM(): Array<PoDynamicFormField> {
    return [
      {
        property: 'CGRPNVL1', 
        optional: true, 
        gridColumns: 4, 
        label: 'Grupo Nvl 1', 
        optionsService: environment.urlApiProtheus+'/wsrpdm/zc0',
        params: {combobox: 'S'},
      },
      {
        property: 'CGRPNVL2', 
        optional: true, 
        gridColumns: 4, 
        label: 'Grupo Nvl 2', 
        optionsService: environment.urlApiProtheus+'/wsrpdm/zc1',
        params: {combobox: 'S', CZC2CODZC1: this.getFilterValue("CGRPNVL1")}
      },
      {
        property: 'CB1XPDM', 
        optional: true, 
        gridColumns: 4, 
        label: 'PDM', 
        optionsService: environment.urlApiProtheus+'/wsrpdm/zc2',
        params: {combobox: 'S', CZC2CODZC2: this.getFilterValue("CGRPNVL2")}
      },
      {
        property: 'CB1POSIPI', 
        optional: true, 
        gridColumns: 6, 
        label: 'NCM'
      },
    ];
  }

  getFilterValue(campo: string) {
    let value: any = "";
    let e = document.getElementsByName(campo);
    if (e.length > 0) {
      let poCombo = e[0].parentNode?.parentNode?.parentNode?.parentNode as HTMLElement;
      if (poCombo) {
        value = poCombo.getAttribute('ng-reflect-model');
      }
    }
    return value ? value : "";
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CB1COD'   , label: 'Código'},
      {property: 'CB1TIPO'  , label: 'Tipo'     , width: '80px'},
      {property: 'CB1UM'    , label: 'UM'       , width: '80px'},
      {property: 'CB1DESC'  , label: 'Descrição'},
      {property: 'CB1XDESCL', label: 'Descrição Longa'},
      {property: 'CB1POSIPI', label: 'NCM'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CB1COD} - ${value.CB1DESC}`;
  }
}
